(function () {
    "use strict";

    // @ngInject
    function MobileAppIntroControllerCtor($scope, $injector, $state, $modalInstance, AppStates, $, $sce,
                                    AnalyticsService, EventsManager, EventService, WorkspaceService, CompaniesManager,
                                    PopupMessageService, UsersManager, UserService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'IntroTipController';

        this.EventsManager = EventsManager;
        this.EventService = EventService;
        this.WorkspaceService = WorkspaceService;
        this.$state = $state;
        this.appStates = AppStates;
        this.modalInstance = $modalInstance;
        this.companiesManager = CompaniesManager;
        this.AnalyticsService = AnalyticsService;
        this.PopupMessageService = PopupMessageService;
        this.UsersManager = UsersManager;
        this.UserService = UserService;
        this.$ = $;
        this.$sce = $sce;

        this.currUser = UsersManager.getCurrUser();
        this.phoneNumber = "";
        if (this.currUser.phone_number) {
            this.phoneNumber = this.currUser.phone_number;
        } else if (this.currUser.company) {
            this.phoneNumber = this.currUser.company.phone_number;
        }

        this.$scope = $scope;
        this.video = { videoTag: 'app/mobile_app/mobile-app-movie', title: '', elementPlayerId: "mobileAppVideo"},

        AnalyticsService.track(this, "load", {unique: "sms_me_link_to_download",source: "popup"});

    }

    Controllers.MobileAppIntroController = Class(Controllers.BaseController, {
        constructor: MobileAppIntroControllerCtor,

        cancelIntroTip: function cancelIntroTip(){
            this.modalInstance.dismiss();
        },

        sendSMSToClient: function sendSMSToClient(){
            this.UserService.sendSMSToUser(this.phoneNumber);
        },

        getVideoHtml: function getVideoHtml(video) {
            var currVideoHtml = this.$.cloudinary.videoTag(video.videoTag,{
                autoplay: true,
                loop: true,
                width: 400,
                height: 400,
                secure: true,
                muted:true,
                playsinline: true,
                fallback_content: "Your browser does not support HTML5 video tags",
                id: video.elementPlayerId }).toHtml();
            return this.$sce.trustAsHtml(currVideoHtml);
        }

    });
}());

